import React, { useState } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const ContactMe = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <div style={{ backgroundColor: 'var(--color-white)' }}>
      {/* Header Section */}
      <section className="section-spacing" style={{ backgroundColor: 'var(--color-gray-100)' }}>
        <div className="container-artworld" style={{ textAlign: 'center' }}>
          <h1 className="section-title" style={{ marginBottom: 'var(--spacing-md)' }}>
            Get in Touch
          </h1>
          <p className="body-text" style={{ maxWidth: '600px', margin: '0 auto' }}>
            I'd love to hear from you. Whether you're interested in artwork, workshops, or just want to connect
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="section-spacing-large">
        <div className="container-artworld">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: 'var(--spacing-2xl)'
          }}>
            {/* Contact Information */}
            <div>
              <h2 className="artist-name" style={{ marginBottom: 'var(--spacing-lg)', fontSize: '1.75rem' }}>
                Contact Information
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-xl)' }}>
                <div style={{ display: 'flex', gap: 'var(--spacing-md)', alignItems: 'flex-start' }}>
                  <div style={{
                    backgroundColor: 'var(--color-gray-100)',
                    padding: 'var(--spacing-sm)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Mail size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="body-text" style={{ fontWeight: '600', marginBottom: 'var(--spacing-xs)' }}>
                      Email
                    </p>
                    <a href="mailto:saloni@artwithsaloni.com" className="body-text" style={{
                      color: 'var(--color-gray-600)',
                      textDecoration: 'none',
                      transition: 'color var(--transition-base)'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--color-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-600)'}
                    >
                      saloni@artwithsaloni.com
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 'var(--spacing-md)', alignItems: 'flex-start' }}>
                  <div style={{
                    backgroundColor: 'var(--color-gray-100)',
                    padding: 'var(--spacing-sm)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Phone size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="body-text" style={{ fontWeight: '600', marginBottom: 'var(--spacing-xs)' }}>
                      Phone
                    </p>
                    <a href="tel:+14039198120" className="body-text" style={{
                      color: 'var(--color-gray-600)',
                      textDecoration: 'none',
                      transition: 'color var(--transition-base)'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--color-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--color-gray-600)'}
                    >
                      +1 (403) 919-8120
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 'var(--spacing-md)', alignItems: 'flex-start' }}>
                  <div style={{
                    backgroundColor: 'var(--color-gray-100)',
                    padding: 'var(--spacing-sm)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <MapPin size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="body-text" style={{ fontWeight: '600', marginBottom: 'var(--spacing-xs)' }}>
                      Studio Location
                    </p>
                    <p className="body-text" style={{ color: 'var(--color-gray-600)' }}>
                      Calgary, Alberta<br />
                      Canada
                    </p>
                  </div>
                </div>
              </div>

              <div style={{
                marginTop: 'var(--spacing-2xl)',
                padding: 'var(--spacing-xl)',
                backgroundColor: 'var(--color-gray-100)',
                borderRadius: '8px'
              }}>
                <h3 className="artist-name" style={{ marginBottom: 'var(--spacing-md)', fontSize: '1.25rem' }}>
                  Workshop Availability
                </h3>
                <div className="body-text" style={{ color: 'var(--color-gray-700)' }}>
                  <p style={{ marginBottom: 'var(--spacing-xs)' }}>Available for community workshops</p>
                  <p style={{ marginBottom: 'var(--spacing-xs)' }}>Children, seniors, and immigrant groups</p>
                  <p>Contact for scheduling and custom sessions</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            {/* <div>
              <h2 className="artist-name" style={{ marginBottom: 'var(--spacing-lg)', fontSize: '1.75rem' }}>
                Send a Message
              </h2>
              {isSubmitted && (
                <div style={{
                  padding: 'var(--spacing-md)',
                  backgroundColor: '#d4edda',
                  color: '#155724',
                  borderRadius: '4px',
                  marginBottom: 'var(--spacing-md)',
                  border: '1px solid #c3e6cb'
                }}>
                  <p className="body-text" style={{ margin: 0, color: '#155724' }}>
                    Thank you! Your message has been sent successfully.
                  </p>
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 'var(--spacing-md)' }}>
                  <label htmlFor="name" className="body-text" style={{ 
                    display: 'block', 
                    marginBottom: 'var(--spacing-xs)',
                    fontWeight: '600'
                  }}>
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: 'var(--spacing-sm)',
                      border: '2px solid var(--color-gray-300)',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      fontFamily: 'Inter, sans-serif',
                      transition: 'border-color var(--transition-base)',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-gray-300)'}
                  />
                </div>

                <div style={{ marginBottom: 'var(--spacing-md)' }}>
                  <label htmlFor="email" className="body-text" style={{ 
                    display: 'block', 
                    marginBottom: 'var(--spacing-xs)',
                    fontWeight: '600'
                  }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: 'var(--spacing-sm)',
                      border: '2px solid var(--color-gray-300)',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      fontFamily: 'Inter, sans-serif',
                      transition: 'border-color var(--transition-base)',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-gray-300)'}
                  />
                </div>

                <div style={{ marginBottom: 'var(--spacing-md)' }}>
                  <label htmlFor="subject" className="body-text" style={{ 
                    display: 'block', 
                    marginBottom: 'var(--spacing-xs)',
                    fontWeight: '600'
                  }}>
                    Subject *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: 'var(--spacing-sm)',
                      border: '2px solid var(--color-gray-300)',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      fontFamily: 'Inter, sans-serif',
                      transition: 'border-color var(--transition-base)',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-gray-300)'}
                  />
                </div>

                <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                  <label htmlFor="message" className="body-text" style={{ 
                    display: 'block', 
                    marginBottom: 'var(--spacing-xs)',
                    fontWeight: '600'
                  }}>
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    style={{
                      width: '100%',
                      padding: 'var(--spacing-sm)',
                      border: '2px solid var(--color-gray-300)',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      fontFamily: 'Inter, sans-serif',
                      transition: 'border-color var(--transition-base)',
                      resize: 'vertical',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--color-gray-300)'}
                  />
                </div>

                <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                  Send Message
                </button>
              </form>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactMe;
